import React, {ReactNode} from 'react';
import {Image} from 'react-bootstrap';
import styled, {useTheme} from 'styled-components';
import {PickUp} from 'assets';
import {getColoredImage} from 'shared/helpers';
import {User} from 'components/customer/Auth/store/userSlice';
import {Depot} from 'components/manufacturer/DepotSettings/depotApi';

interface PickupLocationProps {
    userProfile?: Partial<User>;
    depotSelected?: Depot;
    states: {name: string; id: number}[];
    aside?: ReactNode;
}

const PickupLocation = ({
    depotSelected,
    userProfile,
    states,
    aside,
}: PickupLocationProps) => {
    const theme = useTheme();
    const state = states.find(
        (state) => state.id == userProfile?.manufacturerState
    );

    return (
        <PickupLocationContainer>
            <ImageContainer>
                <Image
                    src={
                        getColoredImage(
                            String(PickUp),
                            '#204380',
                            theme.colors.primary?.main ?? '#204380'
                        ) as string
                    }
                />
            </ImageContainer>
            <Description>
                <p>
                    <strong>Pickup Location</strong>
                </p>
                <p style={{fontSize: '0.85rem'}}>
                    {depotSelected ? (
                        depotSelected.depot_address
                    ) : (
                        <>
                            {userProfile?.manufacturerAddress},{' '}
                            {userProfile?.manufacturerSuburb},{' '}
                            {userProfile?.manufacturerPostCode}
                            {state ? `, ${state.name}` : ''}
                        </>
                    )}
                </p>
            </Description>
            {aside ? <Aside>{aside}</Aside> : null}
        </PickupLocationContainer>
    );
};

const PickupLocationContainer = styled.div<{$primaryColor?: string}>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid
        ${({$primaryColor}) => $primaryColor ?? 'rgb(32, 67, 129)'};
    margin-bottom: 15px;
    flex-wrap: wrap;
    container: pickup-location / inline-size;
`;

const Aside = styled.div`
    flex: 0 0 280px;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    border-left: 1px solid #dee2e6;

    @container pickup-location (max-width: 560px) {
        flex: 1 1 100%;
        padding: 12px 0 0;
        border-left: 0;
        border-top: 1px solid #dee2e6;
    }
`;

const ImageContainer = styled.div`
    flex: 0 0 auto;
    img {
        width: 50px;
    }
`;

const Description = styled.div`
    flex-grow: 1;
    p,
    label {
        margin: 0;
        word-wrap: break-word;
    }
`;

export default PickupLocation;
